import { watchEffect } from '@vue/runtime-core'
import { reactive } from 'vue'

import { user } from './client'
import { log } from './log'

type Status = 'inactive' | 'waiting' | 'pending' | 'ongoing' | 'done'
// eslint-disable-next-line no-var
export var checkoutQueue = reactive({
  init_cart: 'inactive' as Status,
  init_checkout: 'inactive' as Status,
  init_inventory: 'inactive' as Status,
  init_login: 'inactive' as Status,
  manual_login: 'inactive' as Status,
  login_session: 'inactive' as Status,
  magic_link_login: 'inactive' as Status,
  loading_user_preference: 'inactive' as Status,
  loading_address: 'inactive' as Status,
  loading_mandates: 'inactive' as Status,
  loading_checkout_page: 'inactive' as Status,
  checking_step: 'inactive' as Status,
})

watchEffect(async () => {
  // After initializing, load the checkout components
  log(checkoutQueue.init_cart, checkoutQueue.init_checkout, checkoutQueue.init_inventory, checkoutQueue.init_login)
  if (checkoutQueue.init_cart === 'done' &&
      checkoutQueue.init_checkout === 'done' &&
      checkoutQueue.init_inventory === 'done' &&
      checkoutQueue.loading_checkout_page !== 'done' &&
     (checkoutQueue.magic_link_login === 'inactive' || checkoutQueue.magic_link_login === 'done') &&
     (checkoutQueue.loading_address === 'done' || !user.value)) checkoutQueue.loading_checkout_page = 'pending'

  // After we dealt with addresses OR if there is no user and page already loaded, check for checkout step
  if (checkoutQueue.loading_checkout_page === 'done' &&
     (checkoutQueue.login_session === 'inactive' || checkoutQueue.login_session === 'done') &&
     (checkoutQueue.loading_address === 'done' || !user.value)) checkoutQueue.checking_step = 'pending'
})
